import React, { useEffect, useState } from 'react';
import { getSunatCredentials } from '../../services/sunatCredentialsService';

const SunatCredentialsForm = ({ className, onSave }) => {
  const [ruc, setRuc] = useState('');
  const [usuario, setUsuario] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [rucError, setRucError] = useState('');

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    getSunatCredentials()
      .then((res) => {
        if (cancelled) return;
        if (res.success && res.data) {
          setRuc(res.data.ruc || '');
          setUsuario(res.data.usuario_sol || '');
          setRucError('');
        }
      })
      .catch(() => {
        // Silently fail — form stays empty
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  const handleRucChange = (event) => {
    const digits = event.target.value.replace(/\D/g, '');
    setRuc(digits);
    if (digits.length > 0 && digits.length !== 11) {
      setRucError('El RUC debe tener exactamente 11 dígitos');
    } else {
      setRucError('');
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!ruc || !usuario || !password) {
      if (onSave) {
        onSave({ success: false, message: 'Completa todos los campos de SUNAT' });
      }
      return;
    }

    if (ruc.length !== 11) {
      setRucError('El RUC debe tener exactamente 11 dígitos');
      return;
    }

    setSaving(true);
    try {
      if (onSave) {
        await onSave({ ruc, usuario, password });
      }
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className={`bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden ${className || ''}`}>
      <div className="px-6 py-6">
        <div className="mb-6">
          <h2 className="text-lg font-semibold text-gray-800">Credenciales SUNAT</h2>
          <p className="mt-2 text-sm text-gray-500">
            Ingresa la información SOL para consultas y validaciones desde este módulo.
          </p>
        </div>

        {loading ? (
          <div className="py-8 text-center text-sm text-gray-400">Cargando credenciales...</div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label htmlFor="rucInput" className="block text-sm font-medium text-gray-700 mb-2">
                RUC de la empresa
              </label>
              <input
                id="rucInput"
                name="ruc"
                type="text"
                maxLength={11}
                value={ruc}
                onChange={handleRucChange}
                placeholder="20603436955"
                className={`w-full rounded-md border px-3 py-2 text-sm text-gray-900 transition focus:outline-none focus:ring-2 ${
                  rucError
                    ? 'border-red-400 focus:border-red-500 focus:ring-red-500'
                    : 'border-gray-300 focus:border-teal-500 focus:ring-teal-500'
                }`}
              />
              {rucError && (
                <p className="mt-1 text-xs text-red-500">{rucError}</p>
              )}
            </div>

            <div>
              <label htmlFor="usuarioInput" className="block text-sm font-medium text-gray-700 mb-2">
                Usuario SOL
              </label>
              <input
                id="usuarioInput"
                name="usuario"
                type="text"
                maxLength={100}
                value={usuario}
                onChange={(event) => setUsuario(event.target.value)}
                placeholder="CKBOAKAG"
                className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm text-gray-900 transition focus:border-teal-500 focus:outline-none focus:ring-2 focus:ring-teal-500"
              />
            </div>

            <div>
              <label htmlFor="passwordInput" className="block text-sm font-medium text-gray-700 mb-2">
                Contraseña SOL
              </label>
              <input
                id="passwordInput"
                name="password"
                type="password"
                maxLength={100}
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                placeholder="********"
                className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm text-gray-900 transition focus:border-teal-500 focus:outline-none focus:ring-2 focus:ring-teal-500"
              />
            </div>

            <div className="text-sm text-gray-500">
              <strong>Seguridad:</strong> Estas credenciales se almacenan cifradas en el servidor.
            </div>

            <div className="pt-2">
              <button
                type="submit"
                disabled={saving}
                className="inline-flex items-center justify-center rounded-md bg-teal-600 px-4 py-2 text-sm font-semibold text-white shadow-sm transition hover:bg-teal-700 disabled:cursor-not-allowed disabled:opacity-60"
              >
                {saving ? 'Guardando...' : 'Guardar credenciales'}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default SunatCredentialsForm;
